// extracted by mini-css-extract-plugin
export var truncate = "_g-0";